export default __webpack_public_path__ + "static/media/Population Project.2390e73f.jpg";